import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'environments/environment';
import { firstValueFrom } from 'rxjs';
import { AppInformationService } from '../app-information.service';

@Injectable()
export class GivingService {
    static serviceName: string;

    constructor(private http: HttpClient, private appInfo: AppInformationService) {
        GivingService.serviceName = environment.serviceName;
    }

    async processBankData(bankPath: string, assignedMonth) {
        const result = await firstValueFrom<any>(this.http.post(`${GivingService.serviceName}/giving/getCSVDataBank`, { bankPath, assignedMonth }));
        return result;
    }

    async processGivingData(givingPath: string, assignedMonth) {
        const result = await firstValueFrom<any>(this.http.post(`${GivingService.serviceName}/giving/getCSVDataGiving`, { givingPath, assignedMonth }));
        return result;
    }

    async createBatchesServerSide(month: number, year: number, feeAmount: number) {
        const result = await firstValueFrom<any>(
            this.http.post(`${GivingService.serviceName}/giving/createBatches`, {
                month: month,
                year: year,
                fee: feeAmount,
            })
        );
        return result;
    }
}
